import { parseISO } from 'date-fns';

export const convertUtcDateToLocaleTimezone = (date: Date | string): Date => {
    const myDt = typeof date === 'string' ? parseISO(date) : date;
    return new Date(myDt.getTime() + myDt.getTimezoneOffset() * 60 * 1000);
};

export const convertLocaleTimezoneDateToUtc = (date: Date | string): Date => {
    const myDt = typeof date === 'string' ? parseISO(date) : date;
    return new Date(myDt.getTime() - myDt.getTimezoneOffset() * 60 * 1000);
};

export const simpleDateToIsoString = (date: Date | string): string => {
    // A pure date string is already timezone-free : keep its date part as-is
    // (avoid `new Date(str)` which would reinterpret it as UTC midnight and shift the day).
    if (typeof date === 'string') return date.substring(0, 10);
    const MM = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : `${date.getMonth() + 1}`;
    const DD = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
    return `${date.getFullYear()}-${MM}-${DD}`;
};
